import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Register from './pages/Register';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Demography from './pages/Demography';
import { Box } from '@mui/material';

function App() {
  return (
    <Router>
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<Login />} />
           
            <Route path="/register" element={<Register />} />
              <Route path="/demography" element={<Demography />} />
          </Routes>
        </Box>
     
      </Box>
         <Footer />
    </Router>
  );
}

export default App;
